"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.array.sort");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/web.dom.iterable");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'TypeMultSelection',
  props: {
    // 作为分组组名的字段名
    groupKey: {
      type: String,
      default: ''
    },
    // 显示名称的字段名
    label: {
      type: String,
      default: ''
    },
    // 值的字段名
    value: {
      type: String,
      default: ''
    },
    // 是否对组名进行搜索过滤
    isFilterSortList: {
      type: Boolean,
      default: false
    },
    // 组名排序，不传入会根据数据源自动生成
    sortList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 已选值
    selectList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 数据源
    dataList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 搜索栏placeHolder
    placeHolder: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isDataReady: false,
      activeNames: [],
      searchVal: '',
      sort: [],
      filterSort: [],
      list: {},
      filterList: {},
      isIndeterminate: {},
      checkAll: {},
      checkedList: {}
    };
  },
  computed: {
    selectedList: {
      get: function get() {
        return this.selectList;
      },
      set: function set(val) {}
    }
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      // 没有传入sortList则自动根据数据生成组名列表
      if (this.sortList && this.sortList.length) {
        this.sort = this.sortList;
      } else {
        this.sort = [];
        this.dataList.forEach(function (item) {
          if (!_this.sort.includes(item[_this.groupKey])) {
            _this.sort.push(item[_this.groupKey]);
          }
        });
      }
      // 初始化数据
      this.filterSort = (0, _toConsumableArray2.default)(this.sort);
      this.filterSort.forEach(function (sortKey) {
        _this.$set(_this.list, sortKey, []);
        _this.$set(_this.filterList, sortKey, []);
        _this.$set(_this.isIndeterminate, sortKey, false);
        _this.$set(_this.checkAll, sortKey, false);
        _this.$set(_this.checkedList, sortKey, []);
      });
      this.dataList.forEach(function (item) {
        _this.list[item[_this.groupKey]].push(item);
        _this.filterList[item[_this.groupKey]].push(item);
      });
      // 渲染已勾选过的选项
      if (this.selectList && this.selectList.length) {
        this.selectList.forEach(function (i) {
          var findItem = _this.dataList.find(function (item) {
            return item[_this.value] === i;
          });
          var sortKey = findItem[_this.groupKey];
          _this.checkedList[sortKey].push(i);
          if (_this.checkedList[sortKey].length === _this.list[sortKey].length) {
            _this.$set(_this.checkAll, sortKey, true);
            _this.$set(_this.isIndeterminate, sortKey, false);
          } else {
            _this.$set(_this.checkAll, sortKey, false);
            _this.$set(_this.isIndeterminate, sortKey, true);
          }
        });
      }
      this.isDataReady = true;
    },
    // 勾选组名
    handleCheckAllChange: function handleCheckAllChange(val, sortKey) {
      var _this2 = this;
      this.$set(this.checkedList, sortKey, val ? this.list[sortKey].map(function (item) {
        return item[_this2.value];
      }) : []);
      this.$set(this.isIndeterminate, sortKey, false);
      // 同步已选项
      this.selectedList.splice(0, this.selectedList.length);
      this.sort.forEach(function (sortKey) {
        var _this2$selectedList;
        (_this2$selectedList = _this2.selectedList).push.apply(_this2$selectedList, (0, _toConsumableArray2.default)(_this2.checkedList[sortKey]));
      });
      this.$emit('update:selectList', (0, _toConsumableArray2.default)(this.selectedList));
    },
    // 勾选组名下选项
    handleCheckedChange: function handleCheckedChange(value, sortKey) {
      var _this3 = this;
      var checkedCount = value.length;
      this.$set(this.checkAll, sortKey, checkedCount === this.list[sortKey].length);
      this.$set(this.isIndeterminate, sortKey, checkedCount > 0 && checkedCount < this.list[sortKey].length);
      // 同步已选项
      this.selectedList.splice(0, this.selectedList.length);
      this.sort.forEach(function (sortKey) {
        var _this3$selectedList;
        (_this3$selectedList = _this3.selectedList).push.apply(_this3$selectedList, (0, _toConsumableArray2.default)(_this3.checkedList[sortKey]));
      });
      this.$emit('update:selectList', (0, _toConsumableArray2.default)(this.selectedList));
    },
    // 搜索时的处理
    handleSearch: function handleSearch(val) {
      var _this4 = this;
      // 有搜索值时
      if (val) {
        // 对组名进行过滤处理
        if (this.isFilterSortList) {
          this.filterSort = this.sort.filter(function (sortKey) {
            if (sortKey.includes(val)) {
              _this4.$set(_this4.filterList, sortKey, _this4.list[sortKey].filter(function (item) {
                return item[_this4.label];
              }));
              return true;
            } else if (_this4.list[sortKey].find(function (item) {
              return item[_this4.label].includes(val);
            })) {
              _this4.$set(_this4.filterList, sortKey, _this4.list[sortKey].filter(function (item) {
                return item[_this4.label].includes(val);
              }));
              return true;
            } else {
              _this4.$set(_this4.filterList, sortKey, []);
              return false;
            }
          });
          // 不对组名进行过滤处理
        } else {
          this.filterSort = this.sort.filter(function (sortKey) {
            if (_this4.list[sortKey].find(function (item) {
              return item[_this4.label].includes(val);
            })) {
              _this4.$set(_this4.filterList, sortKey, _this4.list[sortKey].filter(function (item) {
                return item[_this4.label].includes(val);
              }));
              return true;
            } else {
              _this4.$set(_this4.filterList, sortKey, []);
              return false;
            }
          });
        }
        this.expandAll();
        // 清空搜索时
      } else {
        this.filterSort = (0, _toConsumableArray2.default)(this.sort);
        this.filterSort.forEach(function (sortKey) {
          _this4.$set(_this4.filterList, sortKey, _this4.list[sortKey].filter(function (item) {
            return item[_this4.label];
          }));
        });
      }
    },
    // 全选，选择当前过滤后的所有组名下的显示中选项
    selectAll: function selectAll() {
      var _this5 = this;
      this.filterSort.forEach(function (sortKey) {
        var tmpList = _this5.filterList[sortKey].map(function (item) {
          return item[_this5.value];
        });
        var addList = _this5.checkedList[sortKey].filter(function (item) {
          return !tmpList.includes(item);
        });
        var repList = [].concat((0, _toConsumableArray2.default)(tmpList), (0, _toConsumableArray2.default)(addList));
        _this5.$set(_this5.checkedList, sortKey, repList);
        _this5.handleCheckedChange(repList, sortKey);
      });
    },
    // 清空，清空当前过滤后的所有组名下的显示中选项
    clearAll: function clearAll() {
      var _this6 = this;
      this.filterSort.forEach(function (sortKey) {
        var tmpList = _this6.filterList[sortKey].map(function (item) {
          return item[_this6.value];
        });
        var repList = _this6.checkedList[sortKey].filter(function (item) {
          return !tmpList.includes(item);
        });
        _this6.$set(_this6.checkedList, sortKey, repList);
        _this6.handleCheckedChange(repList, sortKey);
      });
    },
    // 展开
    expandAll: function expandAll() {
      this.activeNames = (0, _toConsumableArray2.default)(this.filterSort);
    },
    // 收起
    narrowAll: function narrowAll() {
      this.activeNames = [];
    }
  }
};